import React, { ChangeEvent, MouseEvent, KeyboardEvent } from "react";
import { Box, Button, Typography, TextField, InputLabel, styled } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { translate } from "../../../i18n";
import { MyBoxContainer, MyFormControl, MyInputMiniLabel } from "../../../utils/theme";


const TypographyStyled = styled(Typography)(({}) => ({
    margin: "0 1rem",
    fontSize: "16px",
}));

const TextFieldStyled = styled(TextField)(({}) => ({
  width: "60px",
  paddingLeft: "1em",
}));

const ButtonStyled = styled(Button)(({}) => ({
  height: "2.6em", 
  marginTop: "5px",
}));

interface IPaginationProps {
  pageNumber: number | "";
  totalPageCount: number;
  handlePreviousPage: (event: MouseEvent<HTMLButtonElement>) => void;
  handleNextPage: (event: MouseEvent<HTMLButtonElement>) => void;
  handlePageNumberChange: (event: ChangeEvent<{ name?: string; value: unknown }>) => void;
  onPaginationKeyUp: (event: KeyboardEvent<HTMLDivElement>) => void;
}
export class Pagination extends React.Component<IPaginationProps> {
  public render(): JSX.Element {
    return (
      <Box alignItems="center" display="flex" flexDirection="column" sx={{ padding: "15px 8px 8px 0px",}}>
        <InputLabel style={{ fontSize: "11px" }} data-cy="pagination-label">
          {translate("Pagination")}
        </InputLabel>
        <Box display="flex" alignItems="center">
          <ButtonStyled
            disabled={!this.props.pageNumber || this.props.pageNumber <= 1}
            onClick={(e) => this.props.handlePreviousPage(e)}
            variant="contained"
            data-cy="pagination-previous-button">
            <ArrowBackIosIcon />
          </ButtonStyled>
          <TextFieldStyled
            type="tel"
            variant="standard"
            onKeyUp={(e) => this.props.onPaginationKeyUp(e)}
            onChange={(e) => this.props.handlePageNumberChange(e)}
            value={this.props.pageNumber}
            data-cy="pagination-page-number-input"
          />
          <TypographyStyled data-cy="pagination-total-page-label">
            / {this.props.totalPageCount}
          </TypographyStyled>
          <ButtonStyled
            disabled={this.props.pageNumber === this.props.totalPageCount}
            variant="contained"
            color="primary"
            onClick={(e) => this.props.handleNextPage(e)}
            data-cy="pagination-next-button">
            <ArrowForwardIosIcon />
          </ButtonStyled>
        </Box>
      </Box>
    );
  }
}
